module.exports = __webpack_public_path__ + "img/katarina_kitchen_5.a37d4ae2.jpg";